import { render } from "./Order.vue?vue&type=template&id=7af635c1"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"
script.render = render

export default script